<template lang="pug">
div
  Form(:data="questionType", :isSubmitting="isSubmitting", @submit="create")
</template>

<script>
import Form from '../shared/Form.vue'
import useQuestionTypeAdd from './useQuestionTypeAdd'

export default {
  components: {
    Form,
  },

  setup() {
    const { create, questionType, isSubmitting } = useQuestionTypeAdd()

    return {
      questionType,
      create,
      isSubmitting,
    }
  },
}
</script>
